module.exports = __webpack_public_path__ + "static/media/n-Natural numbers.be09f04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/n-Natural numbers.png
// module id = 173
// module chunks = 0